// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
import StyledPassportPage from "./StyledPassportPage-APP_CLIENT.styled";
export default StyledPassportPage;
